import { render, staticRenderFns } from "./Utenti.vue?vue&type=template&id=19855352&"
import script from "./Utenti.vue?vue&type=script&lang=js&"
export * from "./Utenti.vue?vue&type=script&lang=js&"
import style0 from "./Utenti.vue?vue&type=style&index=0&id=19855352&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports